function formatDisplayDate(value) {
  if (value == null || value === "") return "—";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return String(value);
  return date.toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
}

function field(label, value, { readonly = false, showIfEmpty = false } = {}) {
  if (!showIfEmpty && (value == null || value === "")) return null;
  return {
    label,
    value: value == null || value === "" ? "—" : String(value),
    readonly,
  };
}

function normalizeRoleName(roleName) {
  return roleName?.trim() ?? "";
}

export function getProfessionalProfileFields(userData) {
  if (!userData?.profile?.role_name) return [];

  const roleName = normalizeRoleName(userData.profile.role_name);

  if (roleName === "County Architect" && userData.architect_object) {
    const architect = userData.architect_object;
    return [
      field("Architect Number", architect.architect_number, { readonly: true }),
      field("License Expiry Date", formatDisplayDate(architect.license_expiry_date), {
        readonly: true,
      }),
      field("Organisation Name", architect.organisation_name, { readonly: true }),
      field("Firm Registration Number", architect.firm_number, { readonly: true }),
      field("Designation", architect.designation, { readonly: true }),
    ].filter(Boolean);
  }

  if (roleName === "Structural Engineer" && userData.struc_eng_object) {
    const engineer = userData.struc_eng_object;
    return [
      field("Engineer Registration Number", engineer.structural_engineer_number, {
        readonly: true,
      }),
      field("License Expiry Date", formatDisplayDate(engineer.license_expiry_date), {
        readonly: true,
      }),
      field("Organisation Name", engineer.organisation_name, { readonly: true }),
      field("Firm Registration Number", engineer.firm_number, { readonly: true }),
      field("Designation", engineer.designation, { readonly: true }),
    ].filter(Boolean);
  }

  if (roleName === "Physical/Town Planner" && userData.physical_town_planner_object) {
    const planner = userData.physical_town_planner_object;
    return [
      field("Registration Number", planner.registration_number, { readonly: true }),
      field("Organisation Name", planner.organisation_name, { readonly: true }),
      field("Firm Registration Number", planner.firm_number, { readonly: true }),
      field("Designation", planner.designation, { readonly: true }),
    ].filter(Boolean);
  }

  return [];
}

export function hasProfessionalProfileDetails(userData) {
  return getProfessionalProfileFields(userData).length > 0;
}
